const NAME = 'JUNE';
const CNameMapping = {
  [NAME]: NAME,
  June: NAME,
  june: NAME,
};

export { NAME, CNameMapping };
